import { Callout } from "@blueprintjs/core";
import { useMemo } from "react";

type ErrorParams = {
  error: string | null;
  description: string | null;
};

export function ErrorFields() {
  const error = useMemo<ErrorParams>(() => {
    const params = new URLSearchParams(location.search);

    return {
      error: params.get("error"),
      description: params.get("error_description"),
    };
  }, []);

  if (error?.error) {
    return (
      <Callout intent="danger" title={error.error} icon="warning-sign">
        {error.description ?? "No description"}
      </Callout>
    );
  }

  return undefined;
}
